import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import env from "./api";
import "./axios";
import "./prototype";
import "./less";
import _typeof from "formats/typeof.js";

Vue.config.productionTip = false;

Vue.config.productionTip = false;

window._ = _typeof;

function getUrl() {
  env.then((res) => {
    Vue.axios.defaults.baseURL = res && res.api_server;
    api();
  });
}
// 让axios在所有请求的时候带上cookie - 微服务平台需要
function api() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
}

export default getUrl();
